module.exports = __webpack_public_path__ + "img/yakiton_picture.21454328.jpg";